export type OfferCreationResult =
  | { outcome: 'saved' }
  // Offre supprimée : le formulaire redevient une création, rien ne reste en base.
  | { outcome: 'rolledBack'; error: unknown }
  // La suppression a échoué aussi : l'offre reste en base sans contenu complet.
  | { outcome: 'leftOver'; error: unknown };

// Une offre se crée en plusieurs appels (offre, contenus, images, notification) : si l'un échoue
// après la création, on la supprime plutôt que de laisser en base une offre vide que la régie
// afficherait.
export async function saveCreatedOffer(
  saveContents: () => Promise<void>,
  deleteCreatedOffer: () => Promise<boolean>,
): Promise<OfferCreationResult> {
  try {
    await saveContents();
    return { outcome: 'saved' };
  } catch (error) {
    return { outcome: (await deleteCreatedOffer()) ? 'rolledBack' : 'leftOver', error };
  }
}
